import { FluentProvider } from '@fluentui/react-components';
import { PropsWithChildren, useEffect } from 'react';
import { darkTheme, lightTheme } from './fluentuiConfig';

import { useTheme } from '../../store/hooks';
import { LIGHT_THEME } from '../../store/models/theme';
import './ScrollBar.scss';
import './switch-overrides.css';

const FluentUiThemeProvider: React.FC<PropsWithChildren> = (props: PropsWithChildren) => {
    const { children } = props;
    const { theme } = useTheme();
    
    // Apply theme to body element for CSS selectors
    useEffect(() => {
        document.body.setAttribute('data-theme', theme === LIGHT_THEME ? 'light' : 'dark');
    }, [theme]);
    
    
    return <FluentProvider theme={theme === LIGHT_THEME ? lightTheme : darkTheme}>{children}</FluentProvider>;
};

export default FluentUiThemeProvider;
